import { ReactElement } from 'react';
import { Link } from '@mui/material';
import { LambdaWebFunctionSummary } from '@localstack/types';
import { getAWSRowCount, getSchema } from '@localstack/services';

import { LAMBDA_DEFAULT_PAGE_SIZE as DEFAULT_PAGE_SIZE } from '@localstack/constants';

import { MagicTable } from '../../magic/MagicTable';

export type LambdaWebFunctionsTableProps = {
  loading?: boolean;
  selectable?: boolean;
  functions: LambdaWebFunctionSummary[];
  page: number;
  pageSize?: number;
  onPageChange?: (page: number) => unknown;
  hasMore: boolean;
  onSelect?: (names: string[]) => void;
  onViewFunction?: (name: string) => void;
};

export const LambdaWebFunctionsTable = ({
  loading,
  selectable = false,
  functions,
  page,
  pageSize,
  hasMore,
  onPageChange,
  onSelect,
  onViewFunction,
}: LambdaWebFunctionsTableProps): ReactElement => (
  <MagicTable
    schema={getSchema('LambdaWeb')}
    entry="FunctionSummary"
    idAttribute="functionName"
    order={['functionName', 'state', 'stateReason', 'createdAt', 'updatedAt']}
    rows={functions}
    selectable={selectable}
    onSelect={onSelect}
    loading={loading}
    page={page}
    paginationMode="server"
    pageSize={pageSize ?? DEFAULT_PAGE_SIZE}
    rowsPerPageOptions={[DEFAULT_PAGE_SIZE]}
    rowCount={getAWSRowCount({ page, pageSize, DEFAULT_PAGE_SIZE, hasMore, array: functions })}
    onPageChange={onPageChange}
    externalFields={{
      functionName: (row: LambdaWebFunctionSummary) => (
        <Link onClick={() => onViewFunction && onViewFunction(row.functionName as string)} underline="hover">
          {row.functionName}
        </Link>
      ),
    }}
  />
);
